import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs/internal/Observable';
import { FileTransferPayload } from '../models/FileTransferPayload';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  constructor(private toast: ToastrService, private http: HttpClient) { }

  public handleFileUpload(event : any, clientId: number, userId: number): Observable<FileTransferPayload> {
    if(event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      let transferPayload: FileTransferPayload = new FileTransferPayload();

      let obs = new Observable<FileTransferPayload>(observ => {
        //if the file is not a csv, pop a warning
        if(event.target.files[0].name.split('.').pop().toLowerCase() != 'csv') {
          this.toast.error('File must be csv.'); 
          return null;
        }
        else {
          reader.readAsDataURL(event.target.files[0]);
    
          reader.onload = (event) => {
            transferPayload.base64FileString = (<FileReader>event.currentTarget).result.toString();
            transferPayload.clientId = clientId;
            transferPayload.userId = userId;
          } 
  
          reader.onloadend = () => {
            observ.next(transferPayload)
          }
        }
            
      })
      return obs;
    }
  }

  public UploadScreeningBatchFile(filetransfer: FileTransferPayload) {
    return this.http.post<string[]>(environment.baseURl + '/api/screening/batch/upload', filetransfer);
  }
}
